/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class e extends r{constructor(r,e){super(r,"sampler2DShadow",0,(o,s)=>o.bindTexture(r,e(s)))}}export{e as Texture2DShadowBindUniform};
